import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../../modules/Auth/_redux/authRedux";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import BootstrapTable from "react-bootstrap-table-next";
import * as crud from "./operations";
import { ClienDeleteModal } from "./editModal";
import { ActionsColumnFormatter } from "./buttonsActions";
import { Modal, Button } from "react-bootstrap"
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import { useSelector } from "react-redux";

import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import ExcelExport from "../../helper/export-xlsx"
import PDFExport from "../../helper/export-pdf"
import * as _clients from "../CatalogClients/operations"
import axios from "axios"
import paginationFactory from 'react-bootstrap-table2-paginator';
import overlayFactory from 'react-bootstrap-table2-overlay';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { optionsFactory, diff_minutes } from "../../helper/table"
import { useHistory } from "react-router-dom"
import MultiSelect from "react-multi-select-component";
import { useToasts } from 'react-toast-notifications';
import moment from "moment"
const { ExportCSVButton } = CSVExport;
export function CustomResponse(props) {
  const [number, setNumber] = useState("")
  const events = {
    "no-update-number": {
      variant: "success",
      body: "Succesfully Updated",
      child: false
    },
    "update-number": {
      variant: "success",
      body: "Succesfully Updated",
      child: true
    },
    "no-update": {
      variant: "danger",
      body: "Cannot be Updated",
      child: false

    }
  }

  if (!props.event) {
    return null
  }
  return (

    <>
      <Modal show={props.show} onHide={props.onHide}>
        <Modal.Header className={`bg-${events[props.event].variant}`}>
        </Modal.Header>
        <Modal.Body>
          <b>{props.document?.name || ""}</b> {events[props.event].body}
          {events[props.event].child ? (
            <div className="container mt-4">
              <label>
                Reference Number
              </label>
              <input className="form-control col-lg-6 col-xs-12" onChange={({ target }) => setNumber(target.value)} />
            </div>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          {events[props.event].child &&
            <Button onClick={() => {
              props.onHide()
            }} variant="secondary" >
              Cancel
            </Button>}
          <Button onClick={() => {
            props.document.reference_number = number
            crud.updateClient(props.document)
              .then(() => {

                props.onHide()
                window.location.href = "/campaign"
              })

          }} variant={!events[props.event].child ? "secondary" : "success"} disabled={!number && events[props.event].child}>
            {!events[props.event].child ? "close" : "save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}


function CampaignTable(props) {
  
  const history = useHistory()
  const { addToast } = useToasts()
  const { user: snap } = useSelector(state => state.auth);
  const user = snap.uid ? snap : snap.payload

  const [queryng, setQuery] = useState(true)
  const [clients_options, setClients] = useState([])

  const [documents, setDocuments] = useState([]);
  const [edit_show, setEditShow] = useState(false);
  const [delete_show, setDeleteShow] = useState(false);

  const [filter, setFilter] = useState("");
  const [clients_selected, clients_setSelected] = useState([])

  const [activeClient, setActiveClient] = useState({});

  const [selected, setSelected] = useState([])

  const [status_selected, status_setSelected] = useState([])
  const [_options, setOptions] = useState([])
  const [status_options, status_setOptions] = useState([])
  async function fetchData() {

    const [
      clients_query,
      campaigns_query,
      gep_query
    ] = await Promise.all([
      _clients.getClient(""),
      crud.getParents(),
      crud.getStates()
    ])
    const geo_states = gep_query.data.states
    const states = Object.keys(geo_states)
    const options = states.map(key => ({ label: key, value: key }))
    const status_options = ["Waiting for start", "On Going", "Done", "Draft"].map(key => ({ label: key, value: key }))

    const clients = clients_query.data.payload
    const clients_options = clients.map(key => ({ label: key.name, value: key.uid }))
    const clients_hash = clients.reduce((hash, row) => ({ ...hash, [row.uid]: row }), {})

    const campaigns = campaigns_query.data.payload
    const documents = campaigns
    .filter(campaign => campaign.client === user.company_id)
    .map((cpg, key) => {
      const today = new Date();
      const start_future = new Date(`${cpg.start_date}`);
      const end_future = new Date(`${cpg.end_date}`);
      const minuts_start = diff_minutes(start_future, today)
      const minuts_end = diff_minutes(end_future, today)
      const state = minuts_start > 0 ? "Waiting for start" : minuts_end > 0 ? "On Going" : "Done"
      const client = clients_hash[cpg.client] ?? {}
      const start_date = moment(new Date(`${cpg.start_date}`)).format("MMMM/DD/YY")
      const end_date = moment(new Date(`${cpg.end_date}`)).format("MMMM/DD/YY")
      
      return {
        no: Number(key) + 1,
        ...cpg,
        start_date: start_date,
        end_date: end_date,
        locations: cpg.pos.length,
        status: cpg.mode === "draft" ? "Draft" : state,
        client: client.name,
        client_uid: cpg.client,
        states:  cpg.state ?? cpg.states?.join(", "),
        pos_visited: "Cargando..."
      }
    })
    clients_setSelected(clients_options)
    setClients(clients_options)
    setDocuments(documents);
    setOptions(options)
    setSelected(options)

    status_setOptions(status_options)
    status_setSelected(status_options)
    setQuery(false)

  }
  useEffect(() => {
    (async () => {
      fetchData()
    })()
  }, [user.company_id]);
  useEffect(() => {
    (async () => {
      if (!documents.length) {
        return;
      }
      if (documents.every(doc => doc.pos_visited !== "Cargando...")) {
        return;
      }
      const reports = await Promise.all(documents.map(cpg => crud.getReport(cpg.uid)))
      console.log(reports)

      const _documents = documents.map((doc, key) => {
        const report_query = reports[key]
        const report = report_query.data.payload
        const pos = [...new Set(report.map(row => row.pos))]
        const pos_visited = pos.length
        return {
          ...doc,
          pos_visited: `${pos_visited}`
        }
      })
      setDocuments(_documents)
    })()

  }, [documents])
  const [show, setShow] = useState(false)
  const [event, setEvent] = useState("")
  const [document, setDoc] = useState({})

  const toggleShow = (event, document, child) => {
    if (!show) {
      document && setDoc(document)
      event && setEvent(event)
    }
    setShow(!show)
  }
  const controllers = { toggleShow }
  const modal = {
    goPreview: (uid) => {
      history.push({
        pathname: "/campaign/preview/" + uid
      })
    },
    controllers: controllers,
    show: edit_show,
    delete: delete_show,
    client: activeClient,
    handleClose: () => setEditShow(false),
    handleShow: () => setEditShow(true),
    hideDelete: () => setDeleteShow(!delete_show),

    handleDelete: (uid) => {
      crud
        .getClient(uid)
        .then((res) => {
          const client = res.data.payload;
          setActiveClient(client);
          setDeleteShow(true);
        })
        .catch(function (thrown) {
          if (axios.isCancel(thrown)) {
            console.log(`request cancelled:${thrown.message}`)
          } else {
            console.log('another error happened')
          }
        })
    },
    deleteClient: (uid) => {
      crud.deleteClient(uid).then(() => {
        crud.getClients(setDocuments);
        setDeleteShow(!delete_show);
        addToast(process.env["REACT_APP_DELETE"], { appearance: 'success' });


      }).catch(err => {
        addToast(process.env["REACT_APP_NO_DELETE"], { appearance: 'error' });
      })
    },
    update: (client) => {
      crud.updateClient(client).then(() => {
        crud.getClients(setDocuments);
        setEditShow(!edit_show);
      });
    },
    openEdit: (uid) => {
      if (uid) {
        crud
          .getClient(uid)
          .then((res) => {
            const client = res.data.payload;
            setActiveClient(client);
            setEditShow(!edit_show);
          })
          .catch(function (thrown) {
            if (axios.isCancel(thrown)) {
              console.log(`request cancelled:${thrown.message}`)
            } else {
              console.log('another error happened')
            }
          })
      } else {
        setActiveClient({});
        setEditShow(!edit_show);
      }
    },
  };

  const fields = ["name", "description", "start_date", "end_date", "type",]
  const _documents = documents.filter((row) => {
    return row.parent === null
  })
    .filter((row) => {
      if (row.mode === "draft") {
        return row.author === user.uid
      }
      return true
    })
  console.log(_documents)

  const data = _documents
    .filter(campaign => selected.map(row => row.value).includes(campaign.state) || !_options.map(row => row.value).includes(campaign.state))
    .filter(campaign => clients_selected.map(row => row.value).includes(campaign.client_uid))
    .filter(campaign => status_selected.map(row => row.value).includes(campaign.status))
    .filter((data) => {
      for (const field of fields) {
        const _string = String(data[field] ?? "")
        const value = _string.toUpperCase();
        if (value.indexOf(filter.toUpperCase()) >= 0) {
          return true;
        }
      }
      return false;
    })
  const options = optionsFactory(data)
  return (
    <ToolkitProvider
      keyField="uid"
      data={data}
      columns={[...crud.columns, {
        dataField: "action",
        text: "Actions",
        formatter: ActionsColumnFormatter,
        formatExtraData: modal,
        classes: "text-right pr-0",
        headerClasses: "text-right pr-3 ",
        style: {
          color: "green !important",
          minWidth: "200px",
        },
      }]}
      exportCSV={true}
    >
      {
        toolkit => (
          <>
            <CustomResponse show={show} document={document} event={event} onHide={toggleShow} />
            <div

            >

              <div className="card card-custom gutter-b">
                <div className="card-header d-flex justify-content-between">
                  <h5 className="mt-7 card-label">Campaigns List</h5>


                  <div className="card-toolbar">
                    <div className="card mx-2">
                      <div className="card-toolbar">
                        <span className="svg-icon svg-icon-md  mx-2">
                          <SVG
                            src={toAbsoluteUrl("/media/svg/icons/Files/Export.svg")}
                          />
                        </span>
                        <ExportCSVButton
                          {...toolkit.csvProps}
                          className="btn btn-info font-weight-bolder mx-1"
                        >
                          .CSV
                        </ExportCSVButton>
                        <PDFExport columns={fields} data={data} name="campaigns">
                          <button className="btn btn-danger font-weight-bolder mx-1">
                            .PDF
                          </button>
                        </PDFExport>
                        <ExcelExport columns={fields} data={data} name="campaigns">
                          <div className="btn btn-success font-weight-bolder mx-2">
                            .XLS
                          </div>
                        </ExcelExport>
                      </div>
                    </div>

                    <div
                      /* href="#" */
                      className="btn btn-primary font-weight-bolder new-campaign-ref"
                      onClick={() => {
                        /* window.location.href = "/campaign/new"; */
                        history.push("/campaign/new");
                      }}
                    >
                      <span className="svg-icon svg-icon-md">
                        <SVG
                          src={toAbsoluteUrl("/media/svg/icons/Design/Flatten.svg")}
                        />
                      </span>
                      New Campaign
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-2">
                      <input
                        type="text"
                        className="form-control"
                        name="searchText"
                        placeholder="Search"
                        onChange={({ target }) => {
                          const { value } = target;
                          setFilter(value);
                        }}
                      />
                      <small className="form-text text-muted">
                        <b>Search</b> in all fields
                      </small>
                    </div>
                    <div className="col-lg-2">
                      <MultiSelect
                        options={_options}
                        value={selected}
                        onChange={setSelected}
                      />
                      <small className="form-text text-muted">
                        <b>Search</b> by state
                      </small>
                    </div>
                    <div className="col-lg-2">
                      <MultiSelect
                        options={status_options}
                        value={status_selected}
                        onChange={status_setSelected}
                      />
                      <small className="form-text text-muted">
                        <b>Search</b> by status
                      </small>
                    </div>
                  </div>
                  <br />
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    bordered={false}
                    classes="table table-head-custom table-vertical-center  "

                    bootstrap4
                    hover
                    keyField="uid"
                    {...toolkit.baseProps}
                    loading={queryng}
                    pagination={paginationFactory(options)}
                    overlay={overlayFactory({ spinner: true })}
                    noDataIndication={<div className="mr-2 text-muted">No records found</div>}
                  ></BootstrapTable>
                </div>
              </div>
            </div>
            {/* <ClientEditModal {...modal} /> */}
            <ClienDeleteModal {...modal} />
          </>
        )
      }
    </ToolkitProvider>
  );
}
export default injectIntl(connect(null, auth.actions)(CampaignTable));
